export class EmployeeRoleEnum {
    public static readonly AC = new EmployeeRoleEnum('AC', 'AC');
    public static readonly CA_ICS_HBE = new EmployeeRoleEnum('CA_ICS_HBE', 'CA_ICS_HBE');
    public static readonly CA_ICS_VT = new EmployeeRoleEnum('CA_ICS_VT', 'CA_ICS_VT');
    public static readonly CM_EP = new EmployeeRoleEnum('CM_EP', 'CM_EP');
    public static readonly CC = new EmployeeRoleEnum('CC', 'DISCO');
    public static readonly CCL = new EmployeeRoleEnum('CCL', 'DISCO');
    public static readonly CSC = new EmployeeRoleEnum('CSC', 'DISCO');
    public static readonly CSL = new EmployeeRoleEnum('CSL', 'DISCO');
    public static readonly DC = new EmployeeRoleEnum('DC', 'DISCO');
    public static readonly ASC = new EmployeeRoleEnum('ASC', 'DISCO');
    public static readonly CRV_PRO = new EmployeeRoleEnum('CRV_PRO', 'AC');

    private _eForceRole: string;
    private _pricingRole: string;

    constructor(eForceRole: string, pricingRole: string) {
        this._eForceRole = eForceRole;
        this._pricingRole = pricingRole;
    }

    public get eForceRole(): string {
        return this._eForceRole;
    }

    public get pricingRole(): string {
        return this._pricingRole;
    }

    isDisco(): boolean {
        return this.pricingRole === 'DISCO';
    }

    public static getEmployeeRoleEnumFromEforceRole(role: string): EmployeeRoleEnum {
        switch (role) {
            case 'AC':
                return EmployeeRoleEnum.AC
            case 'CA_ICS_HBE':
                return EmployeeRoleEnum.CA_ICS_HBE
            case 'CA_ICS_VT':
                return EmployeeRoleEnum.CA_ICS_VT
            case 'CM_EP':
                return EmployeeRoleEnum.CM_EP
            case 'CC':
                return EmployeeRoleEnum.CC
            case 'CCL':
                return EmployeeRoleEnum.CCL
            case 'CSC':
                return EmployeeRoleEnum.CSC
            case 'ASC':
                return EmployeeRoleEnum.ASC
            case 'CSL':
                return EmployeeRoleEnum.CSL
            case 'DC':
                return EmployeeRoleEnum.DC
            case 'CRV_PRO':
                return EmployeeRoleEnum.CRV_PRO
        }
    }
}
